import { render, staticRenderFns } from "./PinnedResources.vue?vue&type=template&id=67d21b7d"
import script from "./PinnedResources.vue?vue&type=script&setup=true&lang=ts"
export * from "./PinnedResources.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports